;(function() {

  var content;
  var doneContent = false;
  var filterList = [];
  var minMarkerPosition = 70;
  var maxMarkerPosition = 810;
  var isOnPanTimeLine = false;
  var panTimelineLastX = 0;
  var panBiographyLastX = 0;
  var panBiographyScrollbarLastX = 0;

  var youTubePlayerList = [];
  var videoPlayerList = [];

  Language();

  var lang = $('body').attr('class');
  var url = `../assets/timeline/data/data_${lang}.json`;

  $.get( url, onGetContent );

  $('[language]').click(changeLang);

  function changeLang() {
    location.reload();
    lang = $(this).attr('language');
    url = `../assets/timeline/data/data_${lang}.json`;
    $.get( url, onGetContent );
  }


  function onGetContent( data ) {
    if ( typeof data == 'string' ) {
      data = JSON.parse( data );
    }

    content = data;
    doneContent = true;
    setup();
  }

  function setup() {
    if ( !doneContent ) {
      return;
    }

    content = OrderContent( content );

    var objectReturned = CreateCards( content, onClickCard );

    content = objectReturned.content;

    CardsPosition.setup( content );
    CardsPosition.set( 0 );

    $( '.menu #lupa' ).on( 'click', onClickSearch );
    $( '.menu .filtro' ).on( 'click', onClickFilter );
    $( '.menu .filtro-popular' ).on( 'click', onClickPoularFilter );
    $( '.submenu-popular .filtro' ).on( 'click', onClickPopularSubfilter );

    $( '.container' ).hammer({
      recognizers: [ [ Hammer.Pan, { pointers: 0, direction: Hammer.DIRECTION_HORIZONTAL } ] ]
    }).bind( 'panstart panmove panend', function( e ) {
      onPanTimeline( e );
    });

    $( '.ruler .before' ).on( 'click', CardsPosition.goToPreviousCard );
    $( '.ruler .next' ).on( 'click', CardsPosition.goToNextCard );
    $( '.ruler .begin' ).on( 'click', CardsPosition.goToFirstCard );
    $( '.ruler .regua .hit-regua' ).on( 'click', onClickRuler );

    $( document ).on( 'keydown', onKeyDown );

    $( '.ruler .marker' ).hammer({
      recognizers: [ [ Hammer.Pan, { pointers: 0, direction: Hammer.DIRECTION_HORIZONTAL } ] ]
    }).bind( 'panmove panend', onPanRuler );

    $( '.cards-biografia' ).hammer({
      recognizers: [ [ Hammer.Pan, { pointers: 0, direction: Hammer.DIRECTION_HORIZONTAL } ] ]
    }).bind( 'panstart panmove panend', onPanBiography );

    $( '.container-biografia .drag .marker' ).hammer({
      recognizers: [ [ Hammer.Pan, { pointers: 0, direction: Hammer.DIRECTION_HORIZONTAL } ] ]
    }).bind( 'panstart panmove panend', onPanMarkerBiography );

    $( '.container-biografia .drag' ).on( 'click', onClickDragMarkerBiography );

    $( '.container-biografia .close' ).on( 'click', onClickCloseBiography );

    $( '#loading' ).remove();
  }

  function onClickSearch() {
    //$( '.search #search' ).focus();
    $( '.search #search' ).val('');
    $( '.submenu-popular' ).removeClass( 'show' );

    /*if ($('.search').hasClass('show')) {
    } else {
      closeSearch();
    }*/
  }

  function onClickPoularFilter() {
    $( '.menu .filtro' ).removeClass( 'active' );
    $( this ).addClass( 'active' );
    $( '.menu .filtro-popular .subfiltro' ).empty();
    $( '.menu .filtro-popular .subfiltro' ).removeClass( 'active' );
    $( '.submenu-popular' ).toggleClass( 'show' );
    closeSearch();
  }

  function closeSearch() {
    $( '.search' ).removeClass( 'show' );
    $( '.search #search' ).val( '' );
  }

  /*$("#menu-mobile").click(function(){
    $(".menu-mobile").toggleClass("show");
    $(".submenu-popular").removeClass("show");
    closeSearch();
  });*/

  function onClickPopularSubfilter() {
    if ( $( this ).hasClass( 'active' ) ) {
      return;
    }

    filterList = [];

    $( this ).addClass( 'active' );
    $( '.submenu-popular, .submenu-mobile' ).removeClass( 'show' );
    $( '.submenu-popular .filtro' ).removeClass( 'active' );
    $( '.menu .filtro-popular .subfiltro' ).empty();
    $( '.menu .filtro-popular .subfiltro' ).text( $( this ).text() );
    $( '.menu .filtro-popular .subfiltro' ).addClass( 'active' );

    var filter = $( this ).attr( 'link' );
    filterList.push( filter );

    CardsPosition.set( 0 );
    FilterCards( content, filterList );
  }

  function onClickFilter() {
    if ( $( this ).hasClass( 'active' ) ) {
      return;
    }

    $( '.menu .filtro' ).removeClass( 'active' );
    //$( '.menu .filtro-popular, .menu-mobile .filtro' ).removeClass( 'active' );
    $( '.menu .filtro-popular .subfiltro' ).removeClass( 'active' );
    $( '.menu .filtro-popular .subfiltro' ).empty();

    if ( $( this ).hasClass( 'todos' ) ) {
      FilterCards( content, [] );
      $( '.submenu-popular' ).removeClass( 'show' );
      return;
    }

    $( this ).addClass( 'active' );
    $( '.submenu-popular' ).removeClass( 'show' );

    filterList = [];

    var filter = $( this ).attr( 'link' );
    filterList.push( filter );

    FilterCards( content, filterList );
  }

  function onPanBiography( e ) {

    if (e.type == 'panstart') {
      panBiographyLastX = 0;
    }

    BiographyPosition.incrementPixels( panBiographyLastX - e.gesture.deltaX );

    panBiographyLastX = e.gesture.deltaX;
  }

  function onPanMarkerBiography( e ) {
    if (e.type == 'panstart') {
      panBiographyScrollbarLastX = 0;
    }

    var dragWidth = $( '.container-biografia .drag' ).innerWidth();
    var markerWidth = $( '.container-biografia .drag .marker' ).innerWidth();
    var deltaX = panBiographyScrollbarLastX - e.gesture.deltaX;
    var percentage = deltaX / ( dragWidth - markerWidth );

    BiographyPosition.incrementPercent( -percentage );

    panBiographyScrollbarLastX = e.gesture.deltaX;
  }

  function onClickDragMarkerBiography( e ) {
    if ( e.target.className == 'marker' ) {
      return;
    }

    var dragWidth = $( '.container-biografia .drag' ).innerWidth();
    var markerWidth = $( '.container-biografia .drag .marker' ).innerWidth();
    var percentage = ( ( e.offsetX - markerWidth / 2 ) / ( dragWidth - markerWidth ) );

    BiographyPosition.set( percentage );
  }

  function onClickCloseBiography() {
    event.preventDefault();
    BiographyPosition.set(0);

    $( '.cards-biografia .card-texto' ).remove();
    $( '.cards-biografia .card-video' ).remove();
    $( '.cards-biografia .card-audio' ).remove();
    $( '.container-biografia' ).removeClass( 'show' );

    // Remove Cloned Card on Container Biografia
    $( '.container-biografia .card-clone' ).remove();

    /*window.location.replace("#");
    if (typeof window.history.replaceState == 'function') {
      history.replaceState({}, '', window.location.href.slice(0, -1));
    }*/
  }

  function onClickCard() {
    closeSearch();
    var link = $( this ).attr( 'link' );
    var position = parseInt( $( this ).attr( 'position' ) );

    //var href = link;
    //window.location.hash = href;

    if ( isOnPanTimeLine ) {
      return;
    }

    var isFrontCard = $( this ).hasClass( 'show-biography' );

    if ( !isFrontCard ) {
      CardsPosition.incrementPosition( position, true );
    }
    else {
     $.each( content, function( i ) {

        if ( content[i].id == link ) {
          // Clone Card from Timeline
          var cardClone = content[i].dom.clone().addClass( 'card-clone' );

          // Append Cloned Card on Container Biografiacard-clone
          $( '.container-biografia' ).prepend( cardClone );

          var name;

          if ( content[i].nome_completo ) {
            name = content[i].nome_completo;
          } else {
            name = content[i].nome;
          }

          $( '.cards-biografia .card-biografia .nome' ).html( name );

          var completeDate;

          if ( content[i].nascimento.data != undefined || content[i].nascimento.data != null ) {
            $( '.cards-biografia .card-biografia .nascimento' ).removeClass( 'hide' );
            completeDate = content[i].nascimento.data;

            //hack for efemeride + tema 1/1/AAAA
            if (content[i].tipo == 'efemeride' || content[i].tipo == 'tema') {

              if (completeDate.indexOf('1/1/') > -1) {
                completeDate = completeDate.substring(4);
              }
            }

            if ( content[i].nascimento.local != undefined || content[i].nascimento.local != null ) {
              completeDate += ', ' + content[i].nascimento.local;
            }

            $( '.cards-biografia .card-biografia .nascimento .info' ).html( completeDate );
          } else {
            $( '.cards-biografia .card-biografia .nascimento' ).addClass( 'hide' );
          }

          completeDate = '';

          if ( content[i].falecimento != undefined || content[i].falecimento != null ) {

            if ( content[i].falecimento.data != undefined || content[i].falecimento.data != null ) {
              $( '.cards-biografia .card-biografia .falecimento' ).removeClass( 'hide' );
              completeDate += content[i].falecimento.data;

              if ( content[i].falecimento.local != undefined || content[i].falecimento.local != null ) {
                completeDate += ', ' + content[i].falecimento.local;
              }

              $( '.cards-biografia .card-biografia .falecimento .info' ).html( completeDate );
            }
          } else {
            $( '.cards-biografia .card-biografia .falecimento' ).addClass( 'hide' );
          }

          if ( content[i].descricao != undefined || content[i].descricao != null ) {
            $( '.cards-biografia .card-biografia .texto' ).html( content[i].descricao );
          }

          if ( content[i].biografia && content[i].biografia.item ) {
            //youTubePlayerList = [];

            for ( var j = 0; j < content[i].biografia.item.length; j++ ) {
              var card = $( '<div class="card"/>' );
              var ano = $( '<div class="ano"/>' );
              var titulo = $( '<div class="titulo"/>' );

              if ( content[i].biografia.item[j].ano != undefined || content[i].biografia.item[j].ano != null ) {
                ano.html( content[i].biografia.item[j].ano );
              }

              if ( content[i].biografia.item[j].titulo != undefined || content[i].biografia.item[j].titulo != null ) {
                titulo.html( content[i].biografia.item[j].titulo );
              }

              card.append( ano );
              card.append( titulo );

              switch ( content[i].biografia.item[j].tipo ) {
                case 'texto':
                  card.addClass( 'card-texto' );

                  var texto = $( '<div class="texto"/>' );

                  if ( content[i].biografia.item[j].texto != undefined || content[i].biografia.item[j].texto != null ) {
                    texto.html( content[i].biografia.item[j].texto );
                  }

                  card.append( texto );

                  $( '.cards-biografia' ).append( card );
                  break;


                /*case 'video':
                  card.addClass( 'card-video' );

                  var player = $( '<div id="player' + j + '" class="video"/>' );

                  card.append( player );
                  
                  $( '.cards-biografia' ).append( card );
                  var newPlayer;
                  try {
                    newPlayer = createPlayer( ( 'player' + j ) , content[i].biografia.item[j].youtube );
                    youTubePlayerList.push( newPlayer );
                  }
                  catch(err) {
                    alert(err);
                  }
                  break;*/
                

                /*case 'video':
                  card.addClass( 'card-video' );

                  var player = $( '<div id="player' + j + '" class="video"/>' );

                  card.append( player );
                  
                  $( '.cards-biografia' ).append( card );
                  var newPlayer = createPlayer( ( 'player' + j ) , content[i].biografia.item[j].arquivo );

                  videoPlayerList.push( newPlayer );
                  break;

                case 'link':
                  card.addClass( 'card-link' );

                  var player = $( '<div id="link' + j + '" class="link"/>' );

                  card.append( player );
                  
                  $( '.cards-biografia' ).append( card );

                  var newPlayer = createPlayer( ( 'player' + j ) , content[i].biografia.item[j].arquivo );

                  videoPlayerList.push( newPlayer );
                  break;*/
              }
            }
          }

          $( '.container-biografia' )
            .removeClass( 'compositor grupo efemeride tema' )
            .addClass( 'show ' + content[i].tipo )
            .scrollTop(0);

          if($('.container-biografia').hasClass('tema') || $('.container-biografia').hasClass('efemeride')){
            $('.container-biografia').find( '.cards-biografia' ).addClass('history');
          } else {
            console.log('nao tem');
            $('.container-biografia').find( '.cards-biografia' ).removeClass('history');
          }
        }
      });
    }
  }


  /*function createPlayer( playerId, youtubeId ) {
    return new YT.Player( playerId, {
      videoId: youtubeId,
      height: 420,
      width: 210,
      playerVars: {
        autohide: 1,
        controls: 2,
        enablejsapi: 1,
        rel: 0
      },
      events: {
        'onStateChange': onStateChange
      }
    });
  }

  function onStateChange( e ) {
    if ( e.data == YT.PlayerState.PLAYING ) {
      var playingVideo = e.target.a.src;

      for ( var i = 0; i < youTubePlayerList.length; i++ ) {
        if ( youTubePlayerList[i].a.src != playingVideo ) {
          youTubePlayerList[i].stopVideo();
        }
      }
    }
  }

  function createPlayer( playerId, videoId, youtubeId ) {
    videoId = String(videoId || '').replace('.mp4', '.webm').replace('.flv', '.webm').replace('.f4v', '.webm');

    var video = $(`
      <video width="100%" height="202" controls>
        <source src="../assets/videos/${videoId}" type="video/webm">
      </video>
    `);
    video.on('playing', onStateChange);

    $(`#${playerId}`).append(video);

    return video[0];
  }

  function onStateChange( e ) {
    var playingVideo = e.currentTarget;

    for ( var i = 0; i < videoPlayerList.length; i++ ) {
      if ( videoPlayerList[i] != playingVideo ) {
        videoPlayerList[i].pause();
      }
    }
  }*/

  function onPanTimeline( e ) {
    closeSearch();
    
    if ( isBiographyOpen() ) {
      return;
    }

    isOnPanTimeLine = true;

    if (e.type == 'panstart') {
      panTimelineLastX = 0;
    }

    CardsPosition.incrementPosition( (panTimelineLastX - e.gesture.deltaX) / 100 );

    panTimelineLastX = e.gesture.deltaX;

    if ( e.type == 'panend' ) {
      isOnPanTimeLine = false;
      CardsPosition.snapPosition();
    }
  }

  function onClickRuler( e ) {
    proposeMarkerPosition( e.offsetX );
    //console.log(e.offsetX);
  }

  function onPanRuler( e ) {
    var markerPosition = $( '.ruler .marker' ).position().left;
    var ghostPosition = markerPosition + e.gesture.deltaX;

    //console.log(markerPosition, ghostPosition);

    if ( ghostPosition < Ruler.minPosition() ) {
      ghostPosition = Ruler.minPosition();
    }
    if ( ghostPosition > Ruler.maxPosition() ) {
      ghostPosition = Ruler.maxPosition();
    }
    $( '.ruler .ghost-marker' ).css( 'left', ghostPosition + 'px' );

    if (e.type == 'panend') {
      proposeMarkerPosition( ghostPosition );
    }
  }

  function proposeMarkerPosition( markerPosition ) {
    if ( markerPosition < Ruler.minPosition() ) {
      markerPosition = Ruler.minPosition();
    }
    if ( markerPosition > Ruler.maxPosition() ) {
      markerPosition = Ruler.maxPosition();
    }

    var year = parseInt( Map( markerPosition, Ruler.minPosition(), Ruler.maxPosition(), 1500, 2016 ) );
    CardsPosition.setByYear( year );
  }

  function onKeyDown( e ) {
    switch( e.keyCode ) {
      case 37:
      case 38:
        if ( isBiographyOpen() ) {
          BiographyPosition.goToPreviousCard();
        } else {
          CardsPosition.goToPreviousCard();
        }
        e.preventDefault();
        break;

        case 39:
        case 40:
          if ( isBiographyOpen() ) {
            BiographyPosition.goToNextCard();
          } else {
            CardsPosition.goToNextCard();
          }
          e.preventDefault();
          break;

        case 27:
          if ( isBiographyOpen() ) {
            onClickCloseBiography();
          }

          if ( isScreenOpen() ) {
            $( '.tela' ).removeClass( 'show' );
          }
          e.preventDefault();
          break;
    }
  }

  function isBiographyOpen() {
    return $( '.container-biografia' ).hasClass( 'show' );
  }

  function isScreenOpen() {
    return $( '.tela' ).hasClass( 'show' );
  }

  $( '.search #search' ).on( 'input', function( e ) {
    SearchCards( content );
    CardsPosition.set( 0 );
  });

  $( '.search #search' ).on( 'keyup', function( e ) {
    if ( e.keyCode == 13 ) {
      onClickSearch();
    }
  });

  $('.tela .close').on('click', function() {
    $('.tela').removeClass('show');
  });



})();
